import Link from 'components/Next/Link'
import styled, { keyframes } from 'styled-components'

import MarginPadding from 'components/Util/MarginPadding'

import StateContext, { SectorDiversification } from 'components/StateProvider'
import { useContext } from 'react'

const Header = ({  }) => {

  const state = useContext(StateContext)
  
  return (<>
    <S_Header>
      <Link href='/'>
        <S_Logo src={'/simm.png'}/>
      </Link>

      <MarginPadding ml={.25}>
        <Link href='/analytics'>
        <S_Assets>
          <S_Monospace>{
            state.sectorDiversification?.['Total:']?.['Sector $']
          }</S_Monospace>
        </S_Assets>
        </Link>
      </MarginPadding>
      
      <S_Spacer />

      <S_Report href='mailto:leamon@outlook.com?subject=Problem With SIMM App'>Report problem</S_Report>
    </S_Header>

    <S_VSpacer />
  </>)
}

export default Header

const S_VSpacer = styled.div`
  width: 100%;
  height: 60px;
`

const S_Logo = styled.img`
  height: 28px;
`

const S_Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 1rem);
  height: var(--Header_Height);
  background: var(--Primary);
  box-shadow: var(--Neuo);
  display: flex;
  align-items: center;
  z-index: 2;
  padding:  0 1rem;
`

const S_Spacer = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
`

const S_Assets = styled.div`
  color: white;
`

const S_Report = styled.a`
  text-decoration: none;
  margin-right: 1rem;
  font-size: 12px;
  color: #bbb;
`

const S_Monospace = styled.div`
  display: flex;
  font-family: monospace;
  line-height: 0;
  align-items: center;
  margin-left: .5rem;
  font-size: 16px;
`